import type { Locale } from 'antd/es/locale'
import enUS from 'antd/locale/en_US'
import roRo from 'antd/locale/ro_RO'
import ruRU from 'antd/locale/ru_RU'

import type { LanguageEnum } from 'src/api/main'

type Props = {
  label: string
  value: LanguageEnum
  systemValue: Locale
  icon: string
}

export const allLangs: Props[] = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: 'en.svg'
  },
  {
    label: 'Română',
    value: 'ro',
    systemValue: roRo,
    icon: 'ro.svg'
  },
  {
    label: 'Русский',
    value: 'ru',
    systemValue: ruRU,
    icon: 'ru.svg'
  }
]

export const defaultLang = allLangs[0]
